import useEnvService from '@hooks/app/useEnvService';
import useIsCompact from '@hooks/app/useIsCompact';
import { PageHeaderWrapper } from '@ui';
import React, { useState } from 'react';
import { MessagesColSC } from './communication.styled';
import ChatPreview from './components/chat-preview';
import SearchBar from './components/search-bar';

const Communication: React.FC = () => {
  const [peopleQuery, setPeopleQuery] = useState('');
  const isCompact = useIsCompact();

  const onPeopleSearch = (search: string) => {
    setPeopleQuery(search);
  };

  if (isCompact) {
    return (
      <div style={{ marginLeft: 24, marginRight: 24 }}>
        <ChatPreview query={peopleQuery} />
      </div>
    );
  }

  return (
    <PageHeaderWrapper showBreadcrumbs showDivider>
      <MessagesColSC>
        <SearchBar title="chat.your_messages" onSearch={onPeopleSearch} />
        <ChatPreview query={peopleQuery} />
      </MessagesColSC>
    </PageHeaderWrapper>
  );
};

export default Communication;
